export const getAgentLanguagesUrl = (workspaceId?: string, agentId?: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/languages`;
